/**
 * Parent starter template.
 *
 * Persona: busy parent who needs weather, time, local news, and a health check.
 * Tile mix: weather (2×2), clock (2×1), health news (2×1), world news (2×1).
 */
import { BOARD_SCHEMA_VERSION, TILE_SCHEMA_VERSION } from 'briefpane/schema';

export const PARENT_BOARD_RAW: unknown = {
  schemaVersion: BOARD_SCHEMA_VERSION,
  id: 'board_parent',
  createdAt: '2026-07-24T00:00:00.000Z',
  updatedAt: '2026-07-24T00:00:00.000Z',
  grid: { cols: 8, rowHeight: 120, gap: 12 },
  layout: [
    { tileId: 'tile_prwx01', x: 0, y: 0, w: 2, h: 2 },
    { tileId: 'tile_prclk1', x: 2, y: 0, w: 2, h: 1 },
    { tileId: 'tile_prnws1', x: 2, y: 1, w: 2, h: 1 },
    { tileId: 'tile_prnws2', x: 4, y: 0, w: 2, h: 2 },
  ],
  tiles: [
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_prwx01',
      type: 'weather.current',
      source: {
        provider: 'openweathermap',
        params: { lat: 37.77, lon: -122.42, units: 'imperial' },
      },
      refresh: { intervalSec: 900 },
      display: { size: '2x2', variant: 'big-number' },
      glance: { primary: 'tempF', delta: 'vsYesterdayF', state: 'condition' },
      label: 'Weather',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_prclk1',
      type: 'clock.local',
      source: { provider: 'local', params: { tz: 'America/Los_Angeles', format: '12h' } },
      display: { size: '2x1', variant: 'big-number' },
      glance: { primary: 'time', delta: 'date', state: null },
      label: 'Clock',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_prnws1',
      type: 'news.headlines',
      source: { provider: 'gnews', params: { topic: 'health', count: 4 } },
      refresh: { intervalSec: 600 },
      display: { size: '2x1', variant: 'headline' },
      glance: { primary: 'headline', delta: 'source', state: null },
      label: 'Health',
    },
    {
      v: TILE_SCHEMA_VERSION,
      id: 'tile_prnws2',
      type: 'news.headlines',
      source: { provider: 'gnews', params: { topic: 'world', count: 5 } },
      refresh: { intervalSec: 600 },
      display: { size: '2x2', variant: 'list' },
      glance: { primary: 'headline', delta: 'source', state: null },
      label: 'World News',
    },
  ],
};
